import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ed2964b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "WhackAMoleRenderContainer"
};
const _hoisted_2 = {
  class: "ft20"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "下面四个方框中可能藏着地鼠，请你试着敲击，如果击中了藏有地鼠的方格， ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "你将会得到一分，注意地鼠的出现是有一定规律性的，请找到地鼠出现的规律， ", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "尽可能的找到更多的地鼠，下面开始你的打地鼠之旅吧。", -1));
const _hoisted_6 = {
  key: 0,
  src: "https://qn-edudata.oss-cn-beijing.aliyuncs.com/bang.png",
  class: "sqr70 zoom"
};
const _hoisted_7 = {
  key: 1,
  src: "https://qn-edudata.oss-cn-beijing.aliyuncs.com/cuo.png",
  class: "sqr70 shake"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ft20"
}, "闯关成功，点击右下角按钮继续!", -1));
const _hoisted_9 = {
  class: "flex flex-col"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "正确答案：", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "您的答案：", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_row = _resolveComponent("el-row");
  const _component_HamsterCard = _resolveComponent("HamsterCard");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_createElementVNode("span", _hoisted_2, "第" + _toDisplayString($props.data.questionIndex + 1) + "题", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "flex flex-col mt16"
  }, {
    default: _withCtx(() => [_hoisted_3, _hoisted_4, _hoisted_5]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "bothCenter mt32",
    style: {
      "height": "80px"
    }
  }, {
    default: _withCtx(() => [$data.answerState == 1 ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), $data.answerState == 2 ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true)]),
    _: 1
  }), $data.alertVisible ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0,
    class: "bothCenter"
  }, {
    default: _withCtx(() => [_hoisted_8]),
    _: 1
  })) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], i => {
      return _createVNode(_component_el_col, {
        span: 6,
        class: "bothCenter",
        key: `hst${i}`
      }, {
        default: _withCtx(() => [_createVNode(_component_HamsterCard, {
          index: i,
          ref_for: true,
          ref: `hamster${i}`,
          onClick: $event => $options.onClickCard(i)
        }, null, 8, ["index", "onClick"])]),
        _: 2
      }, 1024);
    }), 64))]),
    _: 1
  })), $props.reviewMode ? (_openBlock(), _createBlock(_component_el_row, {
    key: 2,
    class: "bothCenter mt32"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_col, {
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_10, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.data.rightAnswers, (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          type: "info",
          style: {
            "width": "30px"
          },
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(ra + 1), 1)]),
          _: 2
        }, 1024);
      }), 128))]),
      _: 1
    }), $props.review ? (_openBlock(), _createBlock(_component_el_col, {
      key: 0,
      class: "flex items-center"
    }, {
      default: _withCtx(() => [_hoisted_11, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.review.answer.split(','), (ra, rai) => {
        return _openBlock(), _createBlock(_component_el_tag, {
          style: {
            "width": "30px"
          },
          type: $props.data.rightAnswers[rai] == ra ? 'success' : 'danger',
          key: rai
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(parseInt(ra) + 1), 1)]),
          _: 2
        }, 1032, ["type"]);
      }), 128))]),
      _: 1
    })) : _createCommentVNode("", true)])]),
    _: 1
  })) : _createCommentVNode("", true)]);
}